import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4.667 14.667V7.333M1.333 8.667v4.666c0 .737.597 1.334 1.334 1.334h8.95a2 2 0 0 0 1.977-1.696l.718-4.667A2 2 0 0 0 12.336 6H10a.667.667 0 0 1-.667-.667V2.977c0-.908-.736-1.644-1.644-1.644a.55.55 0 0 0-.5.326L4.843 6.937a.67.67 0 0 1-.61.396H2.667c-.737 0-1.334.597-1.334 1.334"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }